import { render, staticRenderFns } from "./aiBasketball.vue?vue&type=template&id=4a73a320&scoped=true&"
import script from "./aiBasketball.vue?vue&type=script&lang=js&"
export * from "./aiBasketball.vue?vue&type=script&lang=js&"
import style0 from "./aiBasketball.vue?vue&type=style&index=0&id=4a73a320&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a73a320",
  null
  
)

export default component.exports